'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _Screen = require('../sprites/Screen');

var _Screen2 = _interopRequireDefault(_Screen);

var _TerminalIcon = require('../sprites/TerminalIcon');

var _TerminalIcon2 = _interopRequireDefault(_TerminalIcon);

var _SignalIcon = require('../sprites/SignalIcon');

var _SignalIcon2 = _interopRequireDefault(_SignalIcon);

var _Terminal = require('./Terminal');

var _Terminal2 = _interopRequireDefault(_Terminal);

var _SignalControl = require('./SignalControl');

var _SignalControl2 = _interopRequireDefault(_SignalControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Group) {
  _inherits(_class, _Phaser$Group);

  function _class(_ref) {
    var game = _ref.game;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game));

    _this.screen = new _Screen2.default({
      game: game,
      x: 0,
      y: 0
    });
    _this.add(_this.screen);

    _this.terminalIcon = new _TerminalIcon2.default({
      game: game,
      x: -210,
      y: 80
    });
    _this.add(_this.terminalIcon);
    _this.terminalIcon.inputEnabled = true;
    _this.terminalIcon.input.useHandCursor = true;
    _this.terminalIcon.events.onInputDown.add(_this.onTerminalOpen, _this);

    _this.signalIcon = new _SignalIcon2.default({
      game: game,
      x: -130,
      y: 80
    });
    _this.add(_this.signalIcon);
    _this.signalIcon.inputEnabled = true;
    _this.signalIcon.input.useHandCursor = true;
    _this.signalIcon.events.onInputDown.add(_this.onSignalOpen, _this);

    _this.terminal = new _Terminal2.default({
      game: _this.game,
      lineCount: 10,
      lineCharWidth: 50
    });
    _this.terminal.x = -285;
    _this.terminal.y = -230;
    _this.add(_this.terminal);

    _this.signalControl = new _SignalControl2.default({
      game: _this.game
    });
    _this.signalControl.x = -285;
    _this.signalControl.y = -230;
    _this.add(_this.signalControl);

    _this.hideIcons();
    _this.signalControl.visible = false;
    _this.terminal.visible = true;
    return _this;
  }

  _createClass(_class, [{
    key: 'unlock',
    value: function unlock() {
      this.showIcons();
    }
  }, {
    key: 'hideIcons',
    value: function hideIcons() {
      this.terminalIcon.visible = false;
      this.signalIcon.visible = false;
    }
  }, {
    key: 'showIcons',
    value: function showIcons() {
      this.terminalIcon.visible = true;
      this.signalIcon.visible = true;
    }
  }, {
    key: 'onTerminalOpen',
    value: function onTerminalOpen() {
      this.signalControl.visible = false;
      this.terminal.visible = true;
    }
  }, {
    key: 'onSignalOpen',
    value: function onSignalOpen() {
      this.terminal.visible = false;
      this.signalControl.visible = true;
    }
  }]);

  return _class;
}(_phaser2.default.Group);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/ui/Desktop.js
// module id = 366
// module chunks = 0